// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__CEEEC","label":"SetPasswdForm_label__3AkbZ"};